module.exports = __webpack_public_path__ + "static/media/ampav.4991c4b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/ampav.mp3
// module id = MRFI
// module chunks = 0